// extracted by mini-css-extract-plugin
module.exports = {"content":"QuestionsList_content__3CL4i"};